/** Calculates and provides dynamic CSS styles and classes for task list items. */
// @ts-check
import { useTaskUI } from '@/features/tasks/context/TaskUIContext';
import { buildTaskItemFlags } from '@/features/tasks/hooks/ui/use-task-item-styles-flags';
import { buildTaskItemPresentation } from '@/features/tasks/hooks/ui/use-task-item-styles-presentation';

/**
 * @param {{
 *   task: Task,
 *   allContexts: string[],
 *   isOverlay: boolean,
 *   isSmallScreen: boolean,
 *   isDragDisabled: boolean,
 *   transform: any,
 *   transition: any,
 *   isDragging: boolean,
 *   isOver?: boolean,
 *   variant: string,
 *   localCompleted: boolean,
 *   isFocused: boolean
 * }} props
 */
export function useTaskItemStyles({
  task,
  allContexts,
  isOverlay,
  isSmallScreen,
  isDragDisabled,
  transform,
  transition,
  isDragging,
  isOver,
  variant,
  localCompleted,
  isFocused,
}) {
  const ui = useTaskUI();
  const flags = buildTaskItemFlags({
    task,
    allContexts,
    localCompleted,
    isFocused,
    isDragging,
    isOver,
    isOverlay,
    ui,
  });

  return buildTaskItemPresentation({
    task,
    allContexts,
    flags,
    isOverlay,
    isSmallScreen,
    isDragDisabled,
    transform,
    transition,
    isDragging,
    variant,
    ui,
  });
}
